/* Filtre collection DHEM sur Typesense — mobile-first.
   Tiroir construit une fois (multi-sélection disjonctive), tri en feuille,
   "Charger plus" + restauration de position, ajout panier (drawer Dawn). */
(function () {
  "use strict";
  var cfg = window.TS_CONFIG;
  var root = document.querySelector(".ts");
  if (!cfg || !root) return;
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";

  function $(id) { return document.getElementById(id); }
  var elGrid = $("tsGrid"), elCount = $("tsCount"), elChips = $("tsChips"), elPicked = $("tsPicked"),
    elFacets = $("tsFacets"), elMore = $("tsMore"), elFilterCount = $("tsFilterCount"),
    elClear = $("tsClear"), drawer = $("tsDrawer"), sortSheet = $("tsSort"),
    elSortOpts = $("tsSortOpts"), elSortLabel = $("tsSortLabel"),
    btnFilters = $("tsOpenFilters"), btnSort = $("tsOpenSort");

  var base = cfg.protocol + "://" + cfg.host + ":" + cfg.port;
  var eur = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
  var PER = cfg.perPage || 24, MAXPP = 250;
  var SORTS = [["popularite:desc", "Populaires"], ["cree_le:desc", "Nouveautés"],
    ["prix:asc", "Prix croissant"], ["prix:desc", "Prix décroissant"]];
  var SKEY = "ts:" + location.pathname;
  var BADGE = cfg.newBadgeLabel || "Nouveau";
  var BAG = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>';
  var CARET = '<svg class="ts-acc__chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 9l6 6 6-6"/></svg>';
  var X = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  // Facettes réelles (champs Typesense) = hors "prix" et hors désactivées.
  var realFacets = cfg.facets.filter(function (f) { return !f.type && !f.disabled; });

  var state = { facets: {}, priceMin: "", priceMax: "", sort: "popularite:desc", page: 1, q: "" };
  function qParams() {
    var q = (state.q || "").trim();
    return { q: q || "*", query_by: q ? "title,marque,sku,description" : "title" };
  }
  var openAcc = {};  // tous les filtres repliés à l'ouverture
  var facetOrder = {}, built = false, countsCache = {}, rendered = 0;

  function esc(s) { return (s == null ? "" : String(s)).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function tick(v) { return "`" + String(v).replace(/`/g, "") + "`"; }
  function alpha(a, b) { return String(a).localeCompare(String(b), "fr", { numeric: true, sensitivity: "base" }); }
  function sizeLine(d) {
    var t = (d.taille && d.taille.length) ? d.taille : ((d.pointure && d.pointure.length) ? d.pointure : []);
    return t.length ? t.join(" / ") : "";
  }
  function isNew(d) {
    var tag = (cfg.newBadgeTag || "").toLowerCase();
    return tag && (d.tags || []).some(function (t) { return String(t).toLowerCase() === tag; });
  }

  function buildFilter(exclude) {
    var parts = [];
    if (!cfg.categoryDriven) parts.push("collections:=" + tick(cfg.collectionHandle));
    realFacets.forEach(function (f) {
      if (f.field === exclude) return;
      var sel = state.facets[f.field];
      if (sel && sel.size) parts.push(f.field + ":=[" + Array.from(sel).map(tick).join(",") + "]");
    });
    if (state.priceMin) parts.push("prix:>=" + parseFloat(state.priceMin));
    if (state.priceMax) parts.push("prix:<=" + parseFloat(state.priceMax));
    return parts.join(" && ");
  }

  function fetchAll(perPage, page) {
    var allFacets = realFacets.map(function (f) { return f.field; }).join(",");
    var qp = qParams();
    var searches = [{ collection: cfg.collection, q: qp.q, query_by: qp.query_by,
      filter_by: buildFilter(null), facet_by: allFacets, max_facet_values: 200, exclude_fields: "description",
      sort_by: (state.q ? "_text_match:desc," + state.sort : state.sort), per_page: perPage, page: page }];
    var sel = realFacets.filter(function (f) { return state.facets[f.field] && state.facets[f.field].size; });
    sel.forEach(function (f) {
      searches.push({ collection: cfg.collection, q: qp.q, query_by: qp.query_by,
        filter_by: buildFilter(f.field), facet_by: f.field, max_facet_values: 200, per_page: 0 });
    });
    return fetch(base + "/multi_search", { method: "POST",
      headers: { "X-TYPESENSE-API-KEY": cfg.apiKey, "Content-Type": "application/json" },
      body: JSON.stringify({ searches: searches }) })
      .then(function (r) { return r.json(); }).then(function (res) {
        var main = res.results[0], counts = {};
        (main.facet_counts || []).forEach(function (fc) { counts[fc.field_name] = fc.counts; });
        sel.forEach(function (f, i) {
          var a = res.results[i + 1];
          var fc = (a.facet_counts || []).find(function (x) { return x.field_name === f.field; });
          if (fc) counts[f.field] = fc.counts;
        });
        return { main: main, counts: counts };
      });
  }

  // ---------- prix (réductions d'affichage settings + prix barré réel) ----------
  function computeDiscount(d) {
    var dc = cfg.discount || {}, pct = 0;
    if (dc.globalOn && dc.globalPct > 0) pct = dc.globalPct;
    if (dc.vendorPct > 0 && dc.vendors) {
      var vends = String(dc.vendors).split(",").map(function (s) { return s.trim(); });
      if (d.marque && vends.indexOf(d.marque) >= 0 && dc.vendorPct > pct) pct = dc.vendorPct;
    }
    if (dc.tagPct > 0 && dc.tags) {
      var tgs = String(dc.tags).split(",").map(function (s) { return s.trim(); });
      if ((d.tags || []).some(function (t) { return tgs.indexOf(t) >= 0; }) && dc.tagPct > pct) pct = dc.tagPct;
    }
    return pct;
  }
  function priceHTML(d) {
    var pct = computeDiscount(d);
    if (pct > 0) {
      return '<span class="ts-card__price ts-card__price--sale">' + eur.format(d.prix * (1 - pct / 100)) + "</span>" +
        '<span class="ts-card__price--old">' + eur.format(d.prix) + "</span>";
    }
    if (d.prix_barre && d.prix_barre > d.prix) {
      return '<span class="ts-card__price ts-card__price--sale">' + eur.format(d.prix) + "</span>" +
        '<span class="ts-card__price--old">' + eur.format(d.prix_barre) + "</span>";
    }
    return '<span class="ts-card__price">' + eur.format(d.prix || 0) + "</span>";
  }

  // ---------- vignettes ----------
  function cardHTML(d) {
    var img = d.image ? d.image.replace(/(\.[a-z]+)(\?|$)/i, "_400x$1$2") : "";
    var href = "/products/" + esc(d.handle);
    var meta = esc(d.categorie || "") + (d.couleur ? ", " + esc(d.couleur) : "");
    var size = sizeLine(d);
    return '<div class="ts-card productgrid--item" data-product-id="' + esc(d.id) + '" data-product-handle="' + esc(d.handle) + '">' +
      '<a class="ts-card__media" href="' + href + '">' +
        (isNew(d) ? '<span class="ts-badge">' + esc(BADGE) + '</span>' : "") +
        (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(d.title) + '">' : "") + "</a>" +
      '<a class="ts-card__brand" href="' + href + '">' + esc(d.marque || d.title || "") + "</a>" +
      '<div class="ts-card__meta">' + meta + "</div>" +
      (size ? '<div class="ts-card__size">' + esc(size) + "</div>" : "") +
      '<div class="ts-card__bottom"><span class="ts-card__prices">' + priceHTML(d) + "</span>" +
        (d.variant_id ? '<button class="ts-card__cart" type="button" data-variant="' + d.variant_id +
          '" aria-label="Ajouter au panier">' + BAG + "</button>" : "") + "</div></div>";
  }
  function bannerHTML(b) {
    return '<div class="ts-banner"><img loading="lazy" src="' + esc(b.image) + '" alt=""></div>';
  }
  function appendCards(docs) {
    if (!docs.length && !elGrid.children.length) { elGrid.innerHTML = '<p class="ts-empty">Aucun produit ne correspond.</p>'; return; }
    var banners = cfg.banners || [], html = "";
    docs.forEach(function (d) {
      html += cardHTML(d);
      rendered += 1;
      banners.forEach(function (b) { if (b.position === rendered) html += bannerHTML(b); });
    });
    elGrid.insertAdjacentHTML("beforeend", html);
  }

  // ---------- facettes ----------
  function priceBlockHTML(label) {
    var po = !!openAcc.__prix;
    return '<div class="ts-acc' + (po ? " is-open" : "") + '" data-facc="__prix">' +
      '<button type="button" class="ts-acc__head" data-acc="__prix">' + esc(label) + CARET + "</button>" +
      '<div class="ts-acc__body"><div class="ts-price"><input type="number" inputmode="numeric" id="tsPmin" placeholder="min" value="' +
      esc(state.priceMin) + '"><span>–</span><input type="number" inputmode="numeric" id="tsPmax" placeholder="max" value="' +
      esc(state.priceMax) + '"><button type="button" id="tsPapply">OK</button></div></div></div>';
  }
  function facetDef(field) { return (cfg.facets || []).filter(function (f) { return f.field === field; })[0] || {}; }
  function fmtVal(field, v) { var f = facetDef(field); return (f.prefix || "") + v + (f.suffix || ""); }
  function optHTML(field, v, cnt, checked) {
    return '<label class="ts-opt"><input type="checkbox" data-field="' + esc(field) + '" value="' + esc(v) + '"' +
      (checked ? " checked" : "") + '><span class="ts-opt__v">' + esc(fmtVal(field, v)) + '</span><span class="ts-opt__n" data-cnt="' +
      esc(field) + "|" + esc(v) + '">' + (cnt || 0) + "</span></label>";
  }
  function facetListHTML(field, values, cmap, sel) {
    return values.map(function (v) { return optHTML(field, v, cmap[v], sel.has(v)); }).join("");
  }
  function buildFacetsDOM(counts) {
    countsCache = counts || countsCache;
    var html = "";
    cfg.facets.forEach(function (f) {
      if (f.disabled || f.hidden) return;   // hidden = filtrable mais pas affichée (ex. reduction pour braderie)
      if (f.type === "price") { html += priceBlockHTML(f.label); return; }
      var vals = (facetOrder[f.field] || []).slice();
      if (!vals.length) return;
      var cmap = {}; (counts[f.field] || []).forEach(function (c) { cmap[c.value] = c.count; });
      var sel = state.facets[f.field] || new Set();
      var listVals = f.searchable ? vals.slice(0, 20) : vals;
      sel.forEach(function (v) { if (listVals.indexOf(v) < 0) listVals.unshift(v); });
      var open = !!openAcc[f.field];
      var search = f.searchable ? '<input type="search" class="ts-facet-search" data-field="' + esc(f.field) + '" placeholder="Rechercher…" autocomplete="off">' : "";
      html += '<div class="ts-acc' + (open ? " is-open" : "") + '" data-facc="' + esc(f.field) + '">' +
        '<button type="button" class="ts-acc__head" data-acc="' + esc(f.field) + '">' + esc(f.label) + CARET + "</button>" +
        '<div class="ts-acc__body">' + search + '<div class="ts-facet-list" data-list="' + esc(f.field) + '">' +
        facetListHTML(f.field, listVals, cmap, sel) + "</div></div></div>";
    });
    elFacets.innerHTML = html;
    built = true;
  }
  function searchFacet(field, term) {
    var listEl = elFacets.querySelector('.ts-facet-list[data-list="' + CSS.escape(field) + '"]'); if (!listEl) return;
    var sel = state.facets[field] || new Set();
    if (!term) {
      var cmap0 = {}; ((countsCache[field]) || []).forEach(function (c) { cmap0[c.value] = c.count; });
      var vals0 = (facetOrder[field] || []).slice(0, 20); sel.forEach(function (v) { if (vals0.indexOf(v) < 0) vals0.unshift(v); });
      listEl.innerHTML = facetListHTML(field, vals0, cmap0, sel); return;
    }
    var qp = qParams();
    var body = { searches: [{ collection: cfg.collection, q: qp.q, query_by: qp.query_by,
      filter_by: buildFilter(field), facet_by: field, facet_query: field + ":" + term, max_facet_values: 40, per_page: 0 }] };
    fetch(base + "/multi_search", { method: "POST", headers: { "X-TYPESENSE-API-KEY": cfg.apiKey, "Content-Type": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); }).then(function (res) {
        var fc = (res.results[0].facet_counts || [])[0], cnts = fc ? fc.counts : [];
        var cmap = {}, vals = []; cnts.forEach(function (c) { cmap[c.value] = c.count; vals.push(c.value); });
        vals.sort(alpha);
        listEl.innerHTML = vals.length ? facetListHTML(field, vals, cmap, sel) : '<div class="ts-opt__none">Aucun résultat</div>';
      }).catch(function () {});
  }
  function updateFacetCounts(counts) {
    realFacets.forEach(function (f) {
      var cmap = {}; (counts[f.field] || []).forEach(function (c) { cmap[c.value] = c.count; });
      var sel = state.facets[f.field] || new Set();
      (facetOrder[f.field] || []).forEach(function (v) {
        var n = elFacets.querySelector('[data-cnt="' + CSS.escape(f.field + "|" + v) + '"]');
        if (n) { n.textContent = cmap[v] || 0; n.parentNode.classList.toggle("ts-opt--empty", !cmap[v] && !sel.has(v)); }
        var cb = elFacets.querySelector('input[data-field="' + CSS.escape(f.field) + '"][value="' + CSS.escape(v) + '"]');
        if (cb) cb.checked = sel.has(v);
      });
    });
    var pmin = $("tsPmin"), pmax = $("tsPmax");
    if (pmin) pmin.value = state.priceMin; if (pmax) pmax.value = state.priceMax;
  }

  // ---------- puces ----------
  function chipsHTML() {
    var h = "";
    if (state.q) {
      h += '<button type="button" class="ts-chip ts-chip--q" data-field="__q">« ' + esc(state.q) + " » " + X + "</button>";
    }
    realFacets.forEach(function (f) {
      var sel = state.facets[f.field]; if (!sel) return;
      sel.forEach(function (v) {
        h += '<button type="button" class="ts-chip" data-field="' + esc(f.field) + '" data-value="' + esc(v) + '">' + esc(fmtVal(f.field, v)) + " " + X + "</button>";
      });
    });
    if (state.priceMin || state.priceMax) {
      h += '<button type="button" class="ts-chip" data-field="__prix">' +
        (state.priceMin ? state.priceMin + " €" : "0") + " – " + (state.priceMax ? state.priceMax + " €" : "∞") + " " + X + "</button>";
    }
    return h;
  }
  function renderChips() {
    var h = chipsHTML();
    elChips.innerHTML = h ? h + '<button type="button" class="ts-chip ts-chip--clear" data-clearall>Tout effacer</button>' : "";
    elPicked.innerHTML = h;
  }

  function renderCount(found) { elCount.textContent = found.toLocaleString("fr-FR") + (found > 1 ? " produits" : " produit"); }
  function updateBar() {
    var n = 0;
    realFacets.forEach(function (f) { var s = state.facets[f.field]; if (s) n += s.size; });
    if (state.priceMin || state.priceMax) n += 1;
    if (state.q) n += 1;
    elFilterCount.textContent = n; elFilterCount.hidden = n === 0;
    var lbl = SORTS.find(function (s) { return s[0] === state.sort; });
    if (lbl) elSortLabel.textContent = lbl[1];
  }
  function updateMore(found) { elMore.hidden = state.page * PER >= found; }

  function froonzeAttach() {
    try {
      if (window.frcp && frcp.wishlist && typeof frcp.wishlist.attachOnCollection === "function") {
        frcp.wishlist.attachOnCollection();
      }
    } catch (e) {}
  }

  function paint(o, append) {
    countsCache = o.counts;
    if (!append) { elGrid.innerHTML = ""; rendered = 0; }
    appendCards(o.main.hits.map(function (h) { return h.document; }));
    froonzeAttach(); setTimeout(froonzeAttach, 900);  // wishlist Froonze (cartes rendues en JS)
    renderCount(o.main.found); updateMore(o.main.found);
    if (!built) buildFacetsDOM(o.counts); else updateFacetCounts(o.counts);
    renderChips(); updateBar();
  }
  function run(append) {
    root.classList.add("ts-loading");
    if (!append) state.page = 1;
    return fetchAll(PER, state.page).then(function (o) {
      paint(o, append); root.classList.remove("ts-loading"); saveState();
    }).catch(function (e) { root.classList.remove("ts-loading"); console.error("TS search error", e); });
  }

  function syncChecks() {
    realFacets.forEach(function (f) {
      var sel = state.facets[f.field] || new Set();
      (facetOrder[f.field] || []).forEach(function (v) {
        var cb = elFacets.querySelector('input[data-field="' + CSS.escape(f.field) + '"][value="' + CSS.escape(v) + '"]');
        if (cb) cb.checked = sel.has(v);
      });
    });
    var pmin = $("tsPmin"), pmax = $("tsPmax");
    if (pmin) pmin.value = state.priceMin; if (pmax) pmax.value = state.priceMax;
  }

  // ---------- position ----------
  function readSaved() { try { return JSON.parse(sessionStorage.getItem(SKEY) || "null"); } catch (e) { return null; } }
  function saveState(scrollY) {
    try { sessionStorage.setItem(SKEY, JSON.stringify({ search: location.search, page: state.page, scrollY: scrollY != null ? scrollY : window.scrollY })); } catch (e) {}
  }

  // ---------- URL ----------
  function syncURL() {
    var q = new URLSearchParams();
    realFacets.forEach(function (f) { var s = state.facets[f.field]; if (s && s.size) q.set(f.field, Array.from(s).join(",")); });
    if (state.priceMin) q.set("prix_min", state.priceMin);
    if (state.priceMax) q.set("prix_max", state.priceMax);
    if (state.sort !== "popularite:desc") q.set("tri", state.sort);
    if (state.q) q.set("q", state.q);
    var str = q.toString();
    history.replaceState(null, "", location.pathname + (str ? "?" + str : ""));
  }
  function parseURL() {
    var q = new URLSearchParams(location.search);
    realFacets.forEach(function (f) { var v = q.get(f.field); if (v) state.facets[f.field] = new Set(v.split(",")); });
    state.priceMin = q.get("prix_min") || "";
    state.priceMax = q.get("prix_max") || "";
    state.sort = q.get("tri") || "popularite:desc";
    state.q = (q.get("q") || cfg.searchQuery || "").trim();
  }
  function changed() {
    state.page = 1; syncURL();
    renderChips(); updateBar(); syncChecks();   // reflet immédiat, indépendant du réseau
    run(false);
  }

  // ---------- panneaux ----------
  function toggleChat(hide) {
    var el = document.getElementById("shopify-chat") || document.querySelector('[id^="shopify-chat"]');
    if (el) el.style.setProperty("display", hide ? "none" : "", "important");
  }
  function openPanel(p) { p.hidden = false; document.body.style.overflow = "hidden"; document.body.classList.add("ts-panel-open"); toggleChat(true); requestAnimationFrame(function () { p.classList.add("is-open"); }); }
  function closePanel(p) { p.classList.remove("is-open"); document.body.style.overflow = ""; document.body.classList.remove("ts-panel-open"); toggleChat(false); setTimeout(function () { if (window.innerWidth < 990) p.hidden = true; }, 250); }

  btnFilters.addEventListener("click", function () { openPanel(drawer); });
  btnSort.addEventListener("click", function () {
    elSortOpts.innerHTML = SORTS.map(function (s) {
      return '<button type="button" class="ts-sortopt' + (s[0] === state.sort ? " is-active" : "") + '" data-sort="' + s[0] + '">' + s[1] + "</button>";
    }).join("");
    openPanel(sortSheet);
  });
  [drawer, sortSheet].forEach(function (p) {
    p.addEventListener("click", function (e) { if (e.target.closest("[data-ts-close]") || e.target.classList.contains("ts-panel__backdrop")) closePanel(p); });
  });
  elSortOpts.addEventListener("click", function (e) {
    var b = e.target.closest("[data-sort]"); if (!b) return;
    state.sort = b.getAttribute("data-sort"); closePanel(sortSheet); changed();
  });

  elFacets.addEventListener("click", function (e) {
    var head = e.target.closest(".ts-acc__head");
    if (head) { var acc = head.parentNode; acc.classList.toggle("is-open"); openAcc[head.getAttribute("data-acc")] = acc.classList.contains("is-open"); return; }
    if (e.target.id === "tsPapply") { state.priceMin = ($("tsPmin").value || "").trim(); state.priceMax = ($("tsPmax").value || "").trim(); changed(); }
  });
  elFacets.addEventListener("change", function (e) {
    var cb = e.target; if (!cb.matches("input[type=checkbox][data-field]")) return;
    var field = cb.getAttribute("data-field"), val = cb.value;
    state.facets[field] = state.facets[field] || new Set();
    if (cb.checked) state.facets[field].add(val); else state.facets[field].delete(val);
    changed();
  });
  var facetSt;
  elFacets.addEventListener("input", function (e) {
    var inp = e.target.closest(".ts-facet-search"); if (!inp) return;
    var field = inp.getAttribute("data-field"), term = inp.value.trim();
    clearTimeout(facetSt); facetSt = setTimeout(function () { searchFacet(field, term); }, 200);
  });

  function onChip(e) {
    if (e.target.closest("[data-clearall]")) { state.facets = {}; state.priceMin = ""; state.priceMax = ""; state.q = ""; changed(); return; }
    var chip = e.target.closest(".ts-chip"); if (!chip) return;
    var field = chip.getAttribute("data-field");
    if (field === "__q") { state.q = ""; }
    else if (field === "__prix") { state.priceMin = ""; state.priceMax = ""; }
    else { var v = chip.getAttribute("data-value"); if (state.facets[field]) state.facets[field].delete(v); }
    changed();
  }
  elChips.addEventListener("click", onChip);
  elPicked.addEventListener("click", onChip);
  elClear.addEventListener("click", function () { state.facets = {}; state.priceMin = ""; state.priceMax = ""; state.q = ""; changed(); });
  elMore.addEventListener("click", function () { state.page += 1; run(true); });

  // ---------- panier (Dawn) ----------
  function toast(msg) {
    var t = document.createElement("div"); t.className = "ts-toast"; t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("is-on"); });
    setTimeout(function () { t.classList.remove("is-on"); setTimeout(function () { t.remove(); }, 300); }, 2200);
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var tmp = document.createElement("div"); tmp.innerHTML = sections[key];
      if (key === "cart-drawer") {
        var live = document.querySelector("cart-drawer");
        var src = tmp.querySelector("cart-drawer") || tmp.querySelector("#CartDrawer") || tmp;
        if (live && src) { live.innerHTML = src.innerHTML; live.classList.remove("is-empty"); }
      } else {
        var b = document.getElementById(key);
        if (b) b.innerHTML = (tmp.querySelector("#" + key) ? tmp.querySelector("#" + key).innerHTML : sections[key]);
      }
    });
  }
  function addToCart(vid, btn) {
    btn.classList.add("ts-cart-loading");
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: ["cart-drawer", "cart-icon-bubble"], sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.classList.remove("ts-cart-loading");
        if (!res.ok) { toast(res.d && res.d.description ? res.d.description : "Article indisponible"); return; }
        btn.classList.add("ts-cart-added"); setTimeout(function () { btn.classList.remove("ts-cart-added"); }, 1500);
        applySections(res.d.sections);
        var cd = document.querySelector("cart-drawer");
        if (cd && typeof cd.open === "function") cd.open(); else toast("Ajouté au panier");
      }).catch(function () { btn.classList.remove("ts-cart-loading"); toast("Erreur réseau"); });
  }

  elGrid.addEventListener("click", function (e) {
    var cart = e.target.closest(".ts-card__cart");
    if (cart) { e.preventDefault(); var vid = parseInt(cart.getAttribute("data-variant"), 10); if (vid) addToCart(vid, cart); return; }
    if (e.target.closest("a")) saveState(window.scrollY);
  });

  var st;
  window.addEventListener("scroll", function () { clearTimeout(st); st = setTimeout(function () { saveState(); }, 250); }, { passive: true });
  window.addEventListener("pagehide", function () { saveState(); });
  document.addEventListener("frcp.wishlist.installed", froonzeAttach);
  document.addEventListener("frcp.wishlist.initialize", froonzeAttach);

  // ---------- init ----------
  function initFacetsSkeleton() {
    var allFacets = realFacets.map(function (f) { return f.field; }).join(",");
    return fetch(base + "/multi_search", { method: "POST",
      headers: { "X-TYPESENSE-API-KEY": cfg.apiKey, "Content-Type": "application/json" },
      body: JSON.stringify({ searches: [{ collection: cfg.collection, q: "*", query_by: "title",
        filter_by: cfg.categoryDriven ? "" : ("collections:=" + tick(cfg.collectionHandle)),
        facet_by: allFacets, max_facet_values: 200, per_page: 0 }] }) })
      .then(function (r) { return r.json(); }).then(function (res) {
        var counts = {}; (res.results[0].facet_counts || []).forEach(function (fc) { counts[fc.field_name] = fc.counts; });
        realFacets.forEach(function (f) { if (counts[f.field]) facetOrder[f.field] = counts[f.field].map(function (c) { return c.value; }).sort(alpha); });
        buildFacetsDOM(counts);
      });
  }

  // Config live depuis l'app (regles de collection pilotees par l'admin Shopify).
  function fetchSiteConfig() {
    if (!cfg.apiBase || !cfg.collectionHandle) return Promise.resolve();
    var CK = "ts_siteconfig_" + cfg.collectionHandle;
    function apply(j) {
      if (j && j.collectionRules) {
        cfg.collectionRules = cfg.collectionRules || {};
        Object.keys(j.collectionRules).forEach(function (h) { cfg.collectionRules[h] = j.collectionRules[h]; });
      }
    }
    try { var c = JSON.parse(sessionStorage.getItem(CK) || "null"); if (c) { apply(c); return Promise.resolve(); } } catch (e) {}
    var ctrl = new AbortController();
    var to = setTimeout(function () { ctrl.abort(); }, 1500);  // ne jamais bloquer la grille
    return fetch(cfg.apiBase.replace(/\/$/, "") + "/api/site-config?handle=" + encodeURIComponent(cfg.collectionHandle), { signal: ctrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (j) { clearTimeout(to); apply(j); try { sessionStorage.setItem(CK, JSON.stringify(j)); } catch (e) {} })
      .catch(function () { clearTimeout(to); });
  }

  parseURL();
  var hadFilters = Object.keys(state.facets).length > 0 || !!state.priceMin || !!state.priceMax;
  Promise.all([initFacetsSkeleton(), fetchSiteConfig()]).then(function () {
    if (!hadFilters) {
      var rule = (cfg.collectionRules || {})[cfg.collectionHandle];
      if (rule) {
        if (rule.facets) Object.keys(rule.facets).forEach(function (fld) { state.facets[fld] = new Set(rule.facets[fld]); });
        if (rule.sort) state.sort = rule.sort;
        syncURL();
      } else if (cfg.categoryDriven) {
        var target = (cfg.forceCategory || cfg.collectionTitle || "").trim().toLowerCase();
        var vals = facetOrder[cfg.categoryField] || [];
        var match = target && vals.filter(function (v) {
          var lv = String(v).toLowerCase();
          return lv === target || lv.indexOf(target) >= 0 || target.indexOf(lv) >= 0;
        })[0];
        if (match) { state.facets[cfg.categoryField] = new Set([match]); syncURL(); }
      }
    }
    var s = readSaved();
    if (s && s.search === location.search && s.page > 1) {
      var pp = Math.min(s.page * PER, MAXPP); state.page = Math.ceil(pp / PER);
      return fetchAll(pp, 1).then(function (o) {
        paint(o, false);
        requestAnimationFrame(function () { window.scrollTo(0, s.scrollY || 0); });
        saveState();
      });
    }
    return run(false);
  });
})();
